import { atom } from "recoil";

export const currentEnrollmentsState = atom({
  key: "currentEnrollmentsState",
  default: null,
});
